var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconGroundBlind = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M21.615 22H5V6.77L13.308 4l8.307 2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.077 15.077V9.538l4.846 5.539zM19.538 15.077V9.538l-4.846 5.539zM17.462 9.538H9.154l4.154 4.154z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGroundBlind, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-ground-blind.f178036d.svg";
export { ForwardRef as ReactComponent };